import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class EvidenciasService{



  constructor(private http: Http,
              private seguridad: SeguridadService
            ){

  }

  getListaEvidencias(){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "ListagetInventarioDeEvidencias", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasNorma(id_norma:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, tokenid: userToken, action: "ListagetEvidencias", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasModulo(id_modulo:number){
  
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo, tokenid: userToken, action: "ListagetEvidencias", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {
    
            if (!this.seguridad.getError(response)){ //si no hay error
             
              return response;

            }

        });
  }  


  moverEvidenciaToModulo(id_evidencia:number,id_modulo:number,id_norma:number){
  
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,id_modulo: id_modulo,id_norma: id_norma, tokenid: userToken, action: "MoverEvidenciaToModulo", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {
 
            if (!this.seguridad.getError(response)){ //si no hay error
             
              return response;

            }

        });
  }  



  moverModuloToArea(id_modulo:number,id_area:number){
  
    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({id_modulo: id_modulo,id_area: id_area, tokenid: userToken, action: "MoverModuloToArea", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {
 
            if (!this.seguridad.getError(response)){ //si no hay error
             
              return response;

            }

        });
  }  

  getListaEvidenciasPenal(id_control:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_control: id_control, tokenid: userToken, action: "PenalGetListaEvidencias", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasMaestraNorma(id_norma_maestra:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma_maestra: id_norma_maestra, id_norma: 0, tokenid: userToken, action: "ListagetEvidenciasMaster", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasAfectaPersonalActividad(id_actividad: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_actividad: id_actividad, tokenid: userToken, action: "ActividadGetListaEvidenciasActividad", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasAfectaPersonal(id_actividad: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_actividad: id_actividad,  tokenid: userToken, action: "ActividadGetListaEvidenciasAfectaPersonal", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  getListaEvidenciasMaestraNormaFiltro(id_norma:number, id_norma_maestra: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, id_norma_maestra:id_norma_maestra, tokenid: userToken, action: "ListagetEvidenciasMaster", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciasMaestraModulo(id_modulo:number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_modulo: id_modulo,  tokenid: userToken, action: "ListagetEvidenciasMaster", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  setEvidenciasMaestrasNorma(id_norma:number, evidencias: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_norma: id_norma, evidencias: evidencias, tokenid: userToken, action: "EvidenciaMasterAsociaNorma", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setEvidenciasAfectaPersonalActividad(id_actividad:number, evidencias: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_actividad: id_actividad, evidencias: evidencias, tokenid: userToken, action: "ActividadSetEvidenciasActividad", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteEvidenciaAfectaPersonalActividad(id_evidencia:number, id_actividad: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_actividad: id_actividad, id_evidencia: id_evidencia, tokenid: userToken, action: "ActividadDelEvidenciasActividad", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }



  getEvidencia(id_evidencia){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,  tokenid: userToken, action: "EvidenciagetEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getEvidenciaPenal(id_evidencia){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,  tokenid: userToken, action: "PenalGetEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getEvidenciaMaestra(id_evidencia){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,  tokenid: userToken, action: "EvidenciaMastergetEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }


  setEvidencia(evidencia: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    evidencia.tokenid = userToken;
    evidencia.action = "EvidenciasetEvidencia";
    evidencia.api_keytoken = AppSettings.API_KEYTOKEN;

    //console.log(evidencia);

    return this.http.post(AppSettings.API_URL, JSON.stringify(evidencia))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setEvidenciaPenal(evidencia: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    evidencia.tokenid = userToken;
    evidencia.action = "PenalSetEvidencia";
    evidencia.api_keytoken = AppSettings.API_KEYTOKEN;

    //console.log(evidencia);

    return this.http.post(AppSettings.API_URL, JSON.stringify(evidencia))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setEvidenciaMaestra(evidencia: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    evidencia.tokenid = userToken;
    evidencia.action = "EvidenciaMastersetEvidencia";
    evidencia.api_keytoken = AppSettings.API_KEYTOKEN;

    //console.log(evidencia);

    return this.http.post(AppSettings.API_URL, JSON.stringify(evidencia))
        .map((response: Response) => {

            console.log(response);

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  setModulosAfectados(modulosafectados: any){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ modulosafectados: modulosafectados, tokenid: userToken, action: "MaestraEvidenciaUpdateChilds", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteEvidencia(id_evidencia:number){

    console.log("Borro evidencia: " + id_evidencia);

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,  tokenid: userToken, action: "EvidenciaDeleteEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteEvidenciaPenal(id_evidencia:number){

    console.log("Borro evidencia: " + id_evidencia);

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,  tokenid: userToken, action: "PenalDeleteEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  deleteEvidenciaMaestra(id_evidencia:number){

    console.log("Borro evidencia: " + id_evidencia);

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_evidencia: id_evidencia,  tokenid: userToken, action: "EvidenciaMasterDeleteEvidencia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getLista(action: string){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: action, api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error
              return response;
            }

        });
  }

  asociaEvidenciaJerarquia(id_jerarquia_norma: any, id_evidencia_hija: number, id_evidencia_padre: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_jerarquia_norma: id_jerarquia_norma, id_evidencia_hija: id_evidencia_hija, id_evidencia_padre: id_evidencia_padre, tokenid: userToken, action: "EvidenciaMasterAsociaEvidenciaJerarquia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }

  getListaEvidenciaJerarquia(id_jerarquia_norma: number){

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ id_jerarquia_norma: id_jerarquia_norma, tokenid: userToken, action: "EvidenciaMasterGetListaEvidenciaJerarquia", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;

            }

        });
  }



}



// WEBPACK FOOTER //
// ./src/app/_services/evidencias.service.ts